import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { updateUserDetailsRequest } from '../../common/features/user/userActions';
import { getCustomerOffersRequest } from '../../common/features/cart/cartActions';
import { ReactComponent as CancelIcon } from '../../common/assets/svg/cancelIconnew.svg';
import { ReactComponent as VerifiedIcon } from '../../common/assets/svg/save.svg';
import DialCodePicker, { CountryCodeData } from '../dialCodePicker';
import { getCountryData } from '../../common/utils/country-data-util';
import countrycodedropdown from '../../common/assets/svg/dropdowncountrycode.svg';
import { deleteCookie, getCookie } from "../../helper/cookieHelper";
import { ACCESS_TOKEN, SERVERKNOWNSALT, USER_DETAILS, USER_ID } from "../../common/constants";
import { showErrorToast, showErrorToastDesktop } from "../../common/utils/toastUtils";


const emailDomains = ['.com', '@gmail.com', '@outlook.com', '@icloud.com', '@yahoo.com'];

const UpdateUserDetails = ({
  onClose,
  countryData,
  data,
  isMobile,
  signInPopupDesktop,
  setCurrentPage,
}: any) => {
  const [emailDomain, setEmailDomain] = useState('');
  const [isCustomDomain, setIsCustomDomain] = useState(false);
  const [showDobPicker, setShowDobPicker] = useState(false);
  const [openPicker, setOpenPicker] = useState<string | null>(null);
  const [dobMonth, setDobMonth] = useState('');
  const [dobDay, setDobDay] = useState('');
  const [dobYear, setDobYear] = useState('');
  const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  const dobCurrentYearInit = new Date().getFullYear();
  const [dobHasSelection, setDobHasSelection] = useState(false);
  const [dobHasSelectionDesktop, setDobHasSelectionDesktop] = useState(false);
  const [dobMonthIdx, setDobMonthIdx] = useState(0);
  const [dobDayIdx, setDobDayIdx] = useState(0);
  const [dobYearIdx, setDobYearIdx] = useState(dobCurrentYearInit - 2000);
  const monthScrollRef = useRef<HTMLDivElement>(null);
  const dayScrollRef = useRef<HTMLDivElement>(null);
  const yearScrollRef = useRef<HTMLDivElement>(null);
  const dobSnapTimers = useRef<(ReturnType<typeof setTimeout> | null)[]>([null, null, null]);
  const DOB_ITEM_HEIGHT = 40;
  const dobMonths = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  const dobDays = Array.from({ length: 31 }, (_, i) => String(i + 1).padStart(2, '0'));
  const dobCurrentYear = dobCurrentYearInit;
  const dobYears = Array.from({ length: dobCurrentYear - 1923 }, (_, i) => String(dobCurrentYear - i));
  const dobMonthNum = String(dobMonthIdx + 1).padStart(2, '0');
  const dobDayNum = dobDays[dobDayIdx];
  const dobYearNum = dobYears[dobYearIdx];
  const dobDisplayValue = dobHasSelection && dobMonthNum && dobDayNum && dobYearNum ? `${dobMonthNum}-${dobDayNum}-${dobYearNum}` : '';
  const userData = useSelector((state: any) => state.auth.userData);
  const dispatch = useDispatch();
  const customerDetails = getCookie(USER_DETAILS) || {};

  const customerIdFromCookie = getCookie(USER_ID) || "";
  const customeremail = customerDetails?.email || '';
  const cdUserData = (() => { try { return JSON.parse(localStorage.getItem('CDUSER') || '{}'); } catch { return {}; } })();
  const customerName = customerDetails?.firstName || customerDetails?.name || cdUserData?.userName || '';
  const restaurantDetails = useSelector((state: any) => state.restaurant.currentRestaurantDetail);
  const [showDialCodePicker, setShowDialCodePicker] = useState(false);
  const [countrySelected, setCountrySelected] = useState<any>(false);
  const [countryDataNew, setCountryData] = useState<CountryCodeData>(
    getCountryData(countryData ? countryData : '', restaurantDetails.country)
  );
  console.log({ countryDataNew });

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    getValues,
    watch,
    clearErrors,
    trigger,
  } = useForm({
    defaultValues: {
      mobile: '',
      firstName: '',
      lastName: '',
      email: '',
    },
  });
  const firstName = watch('firstName');
  const lastName = watch('lastName');
  const email = watch('email');
  const customerNumber = customerDetails?.mobilePhone;

  useEffect(() => {
    if (customerName) {
      setValue('firstName', customerName);
    }
    if (
      customeremail ||
      (restaurantDetails?.platformConfiguration?.sendOtpViaEmail && data?.inputData)
    ) {
      if (restaurantDetails?.platformConfiguration?.sendOtpViaEmail) {
        setValue('email', data?.inputData || customeremail);
      } else {
        setValue('email', customeremail);
      }
    }
    if (customerNumber) {
      setValue('mobile', customerNumber.split('-')[1]);
    }
  }, []);

  const handleEmailChange = (value: string) => {
    // Extract just the part before any @ or . if present
    let cleanEmail = value;
    setValue('email', cleanEmail, { shouldDirty: true });
    clearErrors('email');
  };

  const handleEmailDomainChange = (domain: string) => {
    if (domain) {
      setIsCustomDomain(false);
      setEmailDomain(domain);
      let tempEmail = email || '';
      if (domain.includes('@')) {
        if (tempEmail.includes('.')) tempEmail = tempEmail.split('.')[0];
        if (tempEmail.includes('@')) tempEmail = tempEmail.split('@')[0];
      } else if (domain === '.com') {
        if (tempEmail.includes('.')) tempEmail = tempEmail.split('.')[0];
      }
      tempEmail = tempEmail + domain;
      setValue('email', tempEmail, { shouldDirty: true });
      clearErrors('email');
    }
  };
  const emailOtp = false;
  const updateUserDetailsSuccess = useSelector((state: any) => state.user.updateUserDetailsSuccess);
  const UpdateProfileSuccess = useSelector((state: any) => state.auth.UpdateProfileSuccess);
  const hasSubmitted = useRef(false);
  const submittedPayload = useRef<{ phone: string; firstName: string; email: string } | null>(null);

  // Customer-offers fetch state — defer closing the popup until this settles
  // so the cart renders with eligible coupons already applied.
  const customerOffersLoading = useSelector(
    (state: any) => state.cart?.customerOffersLoading
  );
  const customerOffersSuccess = useSelector(
    (state: any) => state.cart?.customerOffersSuccess
  );
  const customerOffersFailure = useSelector(
    (state: any) => state.cart?.customerOffersFailure
  );
  const [awaitingOffersClose, setAwaitingOffersClose] = useState(false);
  const offersCloseTimeoutRef = useRef<any>(null);

  useEffect(() => {
    if ((UpdateProfileSuccess || updateUserDetailsSuccess) && hasSubmitted.current) {
      // Fetch this (now fully-registered) customer's offers before closing so
      // the cart opens with applied coupons. Falls back to an immediate close
      // when there's nothing to query; a safety timeout prevents a hang.
      const locId = restaurantDetails?.id;
      if (!locId ) {
        onClose();
        return;
      }
      dispatch(
        getCustomerOffersRequest({
          locationId: String(locId),
        })
      );
      setAwaitingOffersClose(true);
      if (offersCloseTimeoutRef.current) clearTimeout(offersCloseTimeoutRef.current);
      offersCloseTimeoutRef.current = setTimeout(() => {
        setAwaitingOffersClose(false);
        onClose();
      }, 6000);
    }
  }, [updateUserDetailsSuccess, UpdateProfileSuccess]);

  useEffect(() => {
    if (showDobPicker) {
      setDobHasSelection(true);
      requestAnimationFrame(() => {
        monthScrollRef.current?.scrollTo({ top: dobMonthIdx * DOB_ITEM_HEIGHT, behavior: 'instant' as ScrollBehavior });
        dayScrollRef.current?.scrollTo({ top: dobDayIdx * DOB_ITEM_HEIGHT, behavior: 'instant' as ScrollBehavior });
        yearScrollRef.current?.scrollTo({ top: dobYearIdx * DOB_ITEM_HEIGHT, behavior: 'instant' as ScrollBehavior });
      });
    }
  }, [showDobPicker]);

  // Close once the deferred offers fetch settles (success OR failure). The
  // REQUEST reducer flips loading=true synchronously on dispatch, so a stale
  // prior success can't close us early.
  useEffect(() => {
    if (!awaitingOffersClose) return;
    if (!customerOffersLoading && (customerOffersSuccess || customerOffersFailure)) {
      if (offersCloseTimeoutRef.current) clearTimeout(offersCloseTimeoutRef.current);
      setAwaitingOffersClose(false);
      onClose();
    }
  }, [awaitingOffersClose, customerOffersLoading, customerOffersSuccess, customerOffersFailure]);

  useEffect(
    () => () => {
      if (offersCloseTimeoutRef.current) clearTimeout(offersCloseTimeoutRef.current);
    },
    []
  );

  const updateUserDetailsuseddata: string = useSelector(
    (state: any) => state.user.usedMobileorEmail
  );
  const watchedemail = watch('email');

  const watchedponenumber = watch('mobile');
  const UpdateProfileErrorMessage = useSelector(
    (state: any) => state.auth.UpdateProfileErrorMessage
  );
  const updateUserDetailsErrorMessage = useSelector(
    (state: any) => state.user.updateUserDetailsErrorMessage
  );

  const coerceErrorMessage = (value: any) => {
    if (typeof value === 'string') return value;
    if (value && typeof value?.message === 'string') return value.message;
    return '';
  };
  const backendErrorMessage =
    coerceErrorMessage(updateUserDetailsErrorMessage) ||
    coerceErrorMessage(UpdateProfileErrorMessage);

  console.log({ updateUserDetailsuseddata, watchedponenumber, backendErrorMessage });
  const normalizedWatchedEmail = String(watchedemail || '').trim().toLowerCase();
  const normalizedUsedEmail = String(updateUserDetailsuseddata || '').trim().toLowerCase();
  const normalizePhone = (value: string) => String(value || '').replace(/\D/g, '');
  const normalizedWatchedMobile = `${countryDataNew?.code || ''}-${watchedponenumber || ''}`;
  const isMobileLinkedMatch =
    normalizePhone(updateUserDetailsuseddata) !== '' &&
    normalizePhone(updateUserDetailsuseddata) === normalizePhone(normalizedWatchedMobile);
  const isEmailLinkedMatch =
    normalizedUsedEmail !== '' && normalizedUsedEmail === normalizedWatchedEmail;
  const hasLinkedError =
    backendErrorMessage !== '' &&
    String(backendErrorMessage).toLowerCase().includes('linked');
  const showMobileError =
    restaurantDetails?.platformConfiguration?.sendOtpViaEmail && backendErrorMessage !== '';
  const showEmailError =
    !restaurantDetails?.platformConfiguration?.sendOtpViaEmail && backendErrorMessage !== '';

  const onSubmit = (formData: any) => {
    // Block API call if current input matches a prior "linked" error condition
      const isMobileLinkedError =
        restaurantDetails?.platformConfiguration?.sendOtpViaEmail &&
        hasLinkedError &&
        isMobileLinkedMatch;

    const isEmailLinkedError =
      !restaurantDetails?.platformConfiguration?.sendOtpViaEmail &&
      hasLinkedError &&
      isEmailLinkedMatch;

    if (isMobileLinkedError || isEmailLinkedError) {
      if (isMobile) {
        showErrorToast(backendErrorMessage);
      } else {
        showErrorToastDesktop(backendErrorMessage);
      }
      return;
    }

    const customerId = userData?.customerId || customerIdFromCookie;

    const hasDesktopDobSelection = Boolean(dobMonth && dobDay && dobYear);
    const desktopDobMonthNum = hasDesktopDobSelection
      ? String(months.indexOf(dobMonth) + 1).padStart(2, '0')
      : '';
    const selectedDob = isMobile
      ? `${dobYearNum}-${dobMonthNum}-${dobDayNum}`
      : hasDesktopDobSelection
      ? `${dobYear}-${desktopDobMonthNum}-${dobDay}`
      : undefined;

    const payload: any = {
      firstName: formData.firstName,
      lastName: formData.lastName,
      email: formData.email,
      mobilePhone: countryDataNew?.code + '-' + formData.mobile,
      customerId,
      sendOtpViaEmail: restaurantDetails?.platformConfiguration?.sendOtpViaEmail,
      isNewUser: true,
    };

    if (selectedDob) {
      payload.dob = selectedDob;
    }

    submittedPayload.current = {
      phone: countryDataNew?.code + '-' + formData.mobile,
      firstName: formData.firstName,
      email: formData.email,
    };
    sessionStorage.setItem('pendingLoyaltyUserData', JSON.stringify(submittedPayload.current));

    // CD/buzzer flow: keep CDUSER.userName in sync with the name the new user just entered so
    // the rewards panel (which reads CDUSER.userName as its single source of truth) shows it.
    // Guard on an existing CDUSER so we never create one outside the CD/buzzer flow.
    try {
      const existingCdUserRaw = localStorage.getItem('CDUSER');
      if (existingCdUserRaw) {
        const existingCdUser = JSON.parse(existingCdUserRaw) || {};
        const fullName = [formData.firstName, formData.lastName]
          .filter((part: string) => part && part.trim())
          .join(' ')
          .trim();
        if (fullName) {
          localStorage.setItem(
            'CDUSER',
            JSON.stringify({ ...existingCdUser, userName: fullName })
          );
        }
      }
    } catch {
      // ignore JSON / quota / privacy-mode failures
    }
    hasSubmitted.current = true;
    dispatch(updateUserDetailsRequest(payload));
  };

  return (
    <>
      {
        isMobile &&(
        <button className={
          isMobile ? 
          restaurantDetails?.platformConfiguration?.sendOtpViaEmail ? 
          backendErrorMessage?.includes('linked') ? 
          'close-btnZa-signup-emailotp-updateEror' : 
          "close-btnZa-signup-emailotp" : 
          "close-btnZa-signup" : 
          "close-btn-otpscreen-desktop"
        }

          onClick={() => onClose()}>
          {/* <img src={cancelIcon} alt="" /> */}
          <CancelIcon
            className="signInCancel-btn"
            onClick={() =>{ onClose()
                deleteCookie(USER_ID);
                deleteCookie(USER_DETAILS);
                deleteCookie(ACCESS_TOKEN);
                deleteCookie(SERVERKNOWNSALT);
            }
            }
          />
        </button>
      )}

      <div className={isMobile ? 'signup-mobile-container' : 'signup-mobile-container-D'}>
        {isMobile && (
          <button
            className={
              restaurantDetails?.platformConfiguration?.sendOtpViaEmail
                ? UpdateProfileErrorMessage?.includes('linked')
                  ? 'close-btnZa-signup-emailotp-updateEror'
                  : 'close-btnZa-signup-emailotp'
                : 'close-btnZa-signup'
            }
            onClick={() => {
              onClose();
              deleteCookie(USER_ID);
              deleteCookie(USER_DETAILS);
              deleteCookie(ACCESS_TOKEN);
            }}
          >
            <CancelIcon className="signInCancel-btn" />
          </button>
        )}
        <div className={isMobile ? 'signup-mobile-card' : 'signup-mobile-card-D'}>
          {/* {isMobile && (
            <button className="close-btn-otpscreen-desktop" onClick={() => onClose()}>
              <CancelIcon className="signInCancel-btn" />
            </button>
          )} */}
          {(isMobile || signInPopupDesktop) && (
            <h1 className="signup-mobile-card-title">Sign Up</h1>
          )}

          <p
            className={
              isMobile
                ? 'otp-subtitle'
                : signInPopupDesktop
                ? 'otp-subtitle-D-popup'
                : 'signup-subtitle-D'
            }
          >
            <span
              className={
                isMobile
                  ? 'otp-subtitle-text'
                  : signInPopupDesktop
                  ? 'otp-subtitle-text-D-popup'
                  : 'otp-subtitle-text-D'
              }
            >
              Welcome, New user. Please enter your details to proceed.
            </span>
            {isMobile ? (
              <>
                <span
                  className={
                    isMobile ? 'otp-subtitle-text-phoneNumber' : 'otp-subtitle-text-phoneNumber-D'
                  }
                  style={{ color: '#E31837' }}
                >
                  {data?.inputData}
                </span>
                <span
                  className={isMobile ? 'otp-subtitle-text-change' : 'otp-subtitle-text-change'}
                  onClick={() => {
                    setCurrentPage('signin');
                  }}
                >
                  Change
                </span>
              </>
            ) : (
              <></>
            )}
          </p>

          <form
            onSubmit={handleSubmit(onSubmit)}
            className={isMobile ? 'signup-form-conatiner' : 'signup-form-conatiner-D'}
          >
            <div className="form-group">
              <label className={isMobile ? 'form-label-M' : 'form-label'}>
                Mobile Number<span className="input-asterisk">*</span>
              </label>
              <div
                className={isMobile ? 'phone-input-container' : 'signup-mobile-input'}
                style={{
                  border:
                    showMobileError
                      ? '1px solid #e52333'
                      : undefined,
                  color:
                    showMobileError
                      ? '#e52333'
                      : undefined,
                }}
              >
                <div
                  className="country-code"
                  onClick={() => {
                    setShowDialCodePicker(!showDialCodePicker);
                    setCountrySelected(!countrySelected);
                  }}
                >
                  <span className="flag">
                    <img className="flag" src={countryDataNew.flag} alt="flag" />
                  </span>
                  <img src={countrycodedropdown} alt="" className="dropdown-icon-Desktop-signup" />
                  <span style={{ color: '#707070' }}>{countryDataNew.code}</span>
                </div>
                <span className="divider-Desktop-signup" />
                <input
                  type="text"
                  className="phone-input"
                  maxLength={10}
                  disabled={!restaurantDetails?.platformConfiguration?.sendOtpViaEmail}
                  style={{
                    color:
                      restaurantDetails?.platformConfiguration?.sendOtpViaEmail &&
                      backendErrorMessage !== '' &&
                      backendErrorMessage?.includes('linked') &&
                      updateUserDetailsuseddata === countryDataNew?.code + '-' + watchedponenumber
                        ? '#e52333'
                        : undefined,
                  }}
                  onKeyDown={e => {
                    if (!/[0-9]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Tab') {
                      e.preventDefault();
                    }
                  }}
                  {...register('mobile', {
                    required: 'Mobile number is required',
                    pattern: {
                      value: /^[0-9]{10}$/,
                      message: 'Enter a valid 10-digit mobile number',
                    },
                  })}
                />
                {!restaurantDetails?.platformConfiguration?.sendOtpViaEmail && (
                  <div className="verified-icon">
                    <VerifiedIcon style={{ color: 'green' }} />
                  </div>
                )}
              </div>
              <div className="dialCode">
                <DialCodePicker
                  showPicker={showDialCodePicker}
                  setShowPicker={setShowDialCodePicker}
                  setCountrySelected={setCountrySelected}
                  setCountryData={setCountryData}
                  inputValue=""
                  countryCode={customerNumber?.split('-')[0]}
                  setIsMobile={true}
                  onlyMobile={true}
                  isMobileNot={true}
                  // width="50%"
                  height="32vh"
                  top="76px"
                />
              </div>
              {errors.mobile && (
                <span className="error-message">{errors.mobile.message as string}</span>
              )}
              {restaurantDetails?.platformConfiguration?.sendOtpViaEmail && showMobileError && (
                <span className="error-message">{backendErrorMessage}</span>
              )}
            </div>

            <div className={isMobile ? 'form-row-M' : 'form-row-D'}>
              <div
                className={`${isMobile ? 'form-group' : 'form-input-mobile-container-names'} ${
                  isMobile && 'half-width'
                }`}
              >
                <label className={isMobile ? 'form-label-M' : 'form-label'}>
                  First Name<span className="input-asterisk">*</span>
                </label>
                <input
                  type="text"
                  className={isMobile ? 'form-input-mobile-firtsname' : 'form-input-D-firtsname'}
                  placeholder=""
                  maxLength={32}
                  autoComplete="new-password"
                  inputMode="text"
                  onPaste={e => {
                    const pastedText = e.clipboardData.getData('text');
                    if (!/^[a-zA-Z]+$/.test(pastedText)) {
                      e.preventDefault();
                    }
                  }}
                  onInput={e => {
                    const input = e.target as HTMLInputElement;
                    input.value = input.value.replace(/[^a-zA-Z]/g, '');
                  }}
                  onKeyDown={e => {
                    const key = e.key;
                    if (key.length > 1 || /^[a-zA-Z]$/.test(key)) {
                      return;
                    }
                    e.preventDefault();
                  }}
                  {...register('firstName', {
                    required: 'First name is required',
                    pattern: {
                      value: /^[A-Za-z ]+$/,
                      message: 'Only alphabets allowed',
                    },
                  })}
                />
                {errors.firstName && (
                  <span className="error-message">{errors.firstName.message as string}</span>
                )}
              </div>

              <div
                className={`${isMobile ? 'form-group' : 'form-input-mobile-container-names'} ${
                  isMobile && 'half-width'
                }`}
              >
                <label className={isMobile ? 'form-label-M' : 'form-label'}>Last Name</label>
                <input
                  type="text"
                  className={isMobile ? 'form-input-mobile-lastname' : 'form-input-D-lastname'}
                  placeholder=""
                  maxLength={32}
                  autoComplete="new-password"
                  inputMode="text"
                  onPaste={e => {
                    const pastedText = e.clipboardData.getData('text');
                    if (!/^[a-zA-Z]+$/.test(pastedText)) {
                      e.preventDefault();
                    }
                  }}
                  onInput={e => {
                    const input = e.target as HTMLInputElement;
                    input.value = input.value.replace(/[^a-zA-Z]/g, '');
                  }}
                  onKeyDown={e => {
                    const key = e.key;
                    if (key.length > 1 || /^[a-zA-Z]$/.test(key)) {
                      return;
                    }
                    e.preventDefault();
                  }}
                  {...register('lastName', {
                    pattern: {
                      value: /^[A-Za-z ]+$/,
                      message: 'Only alphabets allowed',
                    },
                  })}
                />
              </div>
            </div>

            <div className="form-group">
              <label className={isMobile ? 'form-label-M' : 'form-label'}>
                Email<span className="input-asterisk">*</span>
              </label>
              <div className="email-input-container">
                <input
                  type="text"
                  maxLength={32}
                  className={isMobile ? 'email-prefix' : 'email-prefix-mobile-D'}
                  autoComplete="new-password"
                  inputMode="text"
                  readOnly={restaurantDetails?.platformConfiguration?.sendOtpViaEmail}
                  style={{
                    border:
                      showEmailError
                        ? '1px solid #e52333'
                        : undefined,
                    color:
                      showEmailError
                        ? '#e52333'
                        : undefined,
                  }}
                  onPaste={e => {
                    const pastedText = e.clipboardData.getData('text');
                    if (!/^[a-zA-Z0-9@._%+-]$/.test(pastedText)) {
                      e.preventDefault();
                    }
                  }}
                  onKeyDown={e => {
                    const key = e.key;
                    if (
                      key === 'Backspace' ||
                      key === 'Delete' ||
                      key === 'ArrowLeft' ||
                      key === 'ArrowRight' ||
                      key === 'Tab'
                    ) {
                      return;
                    }
                    const allowedChars = /^[a-zA-Z0-9@._%+-]$/;
                    if (!allowedChars.test(key)) {
                      e.preventDefault();
                    }
                  }}
                  placeholder=""
                  {...register('email', {
                    required: 'Email is required',
                    pattern: {
                      value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                      message: 'Enter a valid email',
                    },
                  })}
                  onChange={e => handleEmailChange(e.target.value)}
                  onBlur={() => trigger('email')}
                />
                {errors.email && (
                  <span className="error-message">{errors.email.message as string}</span>
                )}
                {!restaurantDetails?.platformConfiguration?.sendOtpViaEmail && showEmailError && (
                  <span className="error-message">{backendErrorMessage}</span>
                )}
              </div>
              {!restaurantDetails?.platformConfiguration?.sendOtpViaEmail && (
                <div className="email-domain-options">
                  {emailDomains?.map((domain: any) => (
                    <button
                      type="button"
                      className={emailDomain === domain ? 'domain-option active' : 'domain-option'}
                      key={domain}
                      onClick={() => handleEmailDomainChange(domain)}
                    >
                      {domain}
                    </button>
                  ))}
                </div>
              )}
              {/* !isMobile && (
                <div className="dob-section">
                  <p className="dob-heading">Date Of Birth (MM-DD-YYYY)</p>
                  <div className="dob-pickers-row-acc">
                    {([
                      { id: 'month', value: dobMonth, setter: setDobMonth, placeholder: 'Jan',  options: months   },
                      { id: 'day',   value: dobDay,   setter: setDobDay,   placeholder: '01',   options: dobDays  },
                      { id: 'year',  value: dobYear,  setter: setDobYear,  placeholder: '2000', options: dobYears },
                    ] as { id: string; value: string; setter: (v: string) => void; placeholder: string; options: string[] }[]).map(({ id, value, setter, placeholder, options }) => {
                      const isOpen = openPicker === id;
                      return (
                        <div key={id} className="dob-picker-item">
                          <div
                            onClick={() => setOpenPicker(isOpen ? null : id)}
                            className={`dob-picker-trigger-acc${isOpen ? ' open' : ''}`}
                          >
                            <span className={`dob-picker-value${value ? ' has-value' : ''}`}>
                              {value || placeholder}
                            </span>
                            <svg width="12" height="7" viewBox="0 0 12 7" fill="none" className={`dob-picker-arrow${isOpen ? ' open' : ''}`}>
                              <path d="M1 1L6 6L11 1" stroke="#666" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                          </div>
                          {isOpen && (
                            <div className="dob-picker-dropdown">
                              {options.map(opt => {
                                const isSelected = value === opt;
                                return (
                                  <div
                                    key={opt}
                                    onClick={() => { setter(opt); setOpenPicker(null); setDobHasSelectionDesktop(true); }}
                                    className={`dob-picker-option-acc${isSelected ? ' selected' : ''}`}
                                  >
                                    {opt}
                                  </div>
                                );
                              })}
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              ) */}
            </div>

            {/* isMobile && (
              <div className="dob-section-M">
                <p className="dob-heading-M">Date of Birth (MM-DD-YYYY)</p>
                <div
                  className={`dob-trigger-M${showDobPicker ? ' open' : ''}`}
                  onClick={() => setShowDobPicker(!showDobPicker)}
                >
                  <span className={`dob-trigger-text-M${dobDisplayValue ? ' has-value' : ''}`}>
                    {dobDisplayValue || 'Select date'}
                  </span>
                  <svg width="12" height="7" viewBox="0 0 12 7" fill="none" className={`dob-picker-arrow${showDobPicker ? ' open' : ''}`}>
                    <path d="M1 1L6 6L11 1" stroke="#666" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
              </div>
            ) */}

            {isMobile ? (
              <button type="submit" className="continue-button-M">
                Continue
              </button>
            ) : (
              <div className="button-group-Desktop-signup">
                <button
                  type="button"
                  className="cancel-btn-Desktop-signup"
                  onClick={() => {
                    setCurrentPage('signin');
                  }}
                >
                  Change
                </button>
                <button type="submit" className="submit-btn-Desktop-signup">
                  Continue
                </button>
              </div>
            )}

            {/* isMobile && showDobPicker && (
              <div className="dob-drum-container-M">
                <div className="dob-drum-highlight-M" />
                {([
                  { ref: monthScrollRef, items: dobMonths, idx: dobMonthIdx, setIdx: setDobMonthIdx },
                  { ref: dayScrollRef,   items: dobDays,   idx: dobDayIdx,   setIdx: setDobDayIdx   },
                  { ref: yearScrollRef,  items: dobYears,  idx: dobYearIdx,  setIdx: setDobYearIdx  },
                ] as { ref: React.RefObject<HTMLDivElement>; items: string[]; idx: number; setIdx: (i: number) => void }[]).map((col, ci) => (
                  <div
                    key={ci}
                    ref={col.ref}
                    className="dob-drum-col-M"
                    onScroll={() => {
                      const el = col.ref.current;
                      if (!el) return;
                      setDobHasSelection(true);
                      const liveIdx = Math.round(el.scrollTop / DOB_ITEM_HEIGHT);
                      col.setIdx(Math.max(0, Math.min(col.items.length - 1, liveIdx)));
                      if (dobSnapTimers.current[ci]) clearTimeout(dobSnapTimers.current[ci]!);
                      dobSnapTimers.current[ci] = setTimeout(() => {
                        const snapIdx = Math.max(0, Math.min(col.items.length - 1, Math.round(el.scrollTop / DOB_ITEM_HEIGHT)));
                        col.setIdx(snapIdx);
                        el.scrollTo({ top: snapIdx * DOB_ITEM_HEIGHT, behavior: 'smooth' });
                        dobSnapTimers.current[ci] = null;
                      }, 120);
                    }}
                  >
                    <div style={{ height: `${DOB_ITEM_HEIGHT * 4}px` }} />
                    {col.items.map((item, i) => {
                      const dist = i - col.idx;
                      const absDist = Math.abs(dist);
                      const angle = dist * 17;
                      const rad = (absDist * 17 * Math.PI) / 180;
                      const opacity = absDist === 0 ? 1 : absDist === 1 ? 0.65 : absDist === 2 ? 0.4 : absDist === 3 ? 0.2 : absDist === 4 ? 0.08 : 0;
                      const scaleY = Math.cos(rad);
                      return (
                        <div
                          key={item}
                          className={`dob-drum-item-M${i === col.idx ? ' selected' : ''}`}
                          style={{ opacity, transform: `perspective(450px) rotateX(${angle}deg) scaleY(${scaleY})` }}
                          onClick={() => {
                            setDobHasSelection(true);
                            col.setIdx(i);
                            if (col.ref.current) {
                              col.ref.current.scrollTo({ top: i * DOB_ITEM_HEIGHT, behavior: 'smooth' });
                            }
                          }}
                        >
                          {item}
                        </div>
                      );
                    })}
                    <div style={{ height: `${DOB_ITEM_HEIGHT * 4}px` }} />
                  </div>
                ))}
              </div>
            ) */}
          </form>
        </div>
      </div>
    </>
  );
};

export default UpdateUserDetails;
